import script from "./KioskCardOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskCardOverlay.vue?vue&type=script&setup=true&lang=js"

import "./KioskCardOverlay.vue?vue&type=style&index=0&id=7c756af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c756af8"]])

export default __exports__